import { Component, DestroyRef, EventEmitter, Input, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { BehaviorSubject, Observable, distinctUntilChanged, map, switchMap } from 'rxjs';
import { CopilotConversation } from '../models/copilot.interface';

@Component({
  selector: 'sbnb-chat-list',
  templateUrl: './chat-list.component.html',
})
export class ChatListComponent {
  // Inputs
  @Input() conversations$: Observable<{ data: CopilotConversation[] }> | null = null;
  @Input() currentConversationUuid: string | null = null;
  @Input() openDropdownId: string | null = null;
  @Input() isMobile$: Observable<boolean> | null = null;
  @Output() conversationClicked = new EventEmitter<CopilotConversation>();
  @Output() newChatClicked = new EventEmitter<void>();
  @Output() dropdownToggled = new EventEmitter<{ event: Event; conversationUuid: string }>();
  @Output() deleteClicked = new EventEmitter<{ event: Event; conversation: CopilotConversation }>();
  @Output() closeClicked = new EventEmitter<void>();

  // Dependencies
  private destroyRef = inject(DestroyRef);

  searchQuery$ = new BehaviorSubject<string>('');
  filteredConversations$ = this.searchQuery$.pipe(
    distinctUntilChanged(),
    switchMap((query) =>
      this.conversations$.pipe(
        map((conversations) =>
          conversations.data.filter((conversation) =>
            conversation.description?.toLowerCase().includes(query.toLowerCase())
          )
        )
      )
    ),
    takeUntilDestroyed(this.destroyRef)
  );

  constructor(private deviceDetectionService: DeviceDetectionService) {}

  handleConversationClick(conversation: CopilotConversation): void {
    this.conversationClicked.emit(conversation);
  }

  handleNewChat(): void {
    this.newChatClicked.emit();
  }

  handleDeleteClick(event: Event, conversation: CopilotConversation): void {
    this.deleteClicked.emit({ event, conversation });
  }

  handleSearchChange(query: string): void {
    this.searchQuery$.next(query.toLowerCase());
  }

  close(): void {
    this.closeClicked.emit();
  }
}
